import React from 'react';
import '../styles/MiniExcavators.css';

const MiniExcavators = () => {
  return (
    <section className="mini-excavators">
      <div className="mini-container">
        <div className="mini-image">
          <img 
            src="/assets/images/mini-excavator.png" 
            alt="Mini pelle LiuGong" 
          />
        </div>
        
        <div className="mini-text">
          <h2 className="mini-title">MINI-PELLES</h2>
          <h3 className="mini-models">3 TONNES CLG9035E ET 6 TONNES CLG906F</h3>
          <p className="mini-tagline">" Compactes et efficaces pour les petits espaces "</p>
          
          <div className="mini-description">
            <p>
              Parfaites pour les environnements restreints, nos mini-pelles garantissent
              performance et flexibilité dans les travaux de précision.
            </p>
          </div>
          
          <a href="/products/min-excavator" className="mini-button">
            NOS MINI-PELLES
          </a>
        </div>
      </div>
    </section>
  );
};

export default MiniExcavators;